/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'./internal/DrillThroughManageComponents',
	'react-dom',
	'react'
], function ($, resources, View, DrillThroughManageComponents,ReactDOM,React) {

	class DrillThroughManageDialog extends View {

		init(...args){
			const properties = args[0] || {};
			super.init(...args);
			this.label = resources.get('drillthrough_manageJumpPaths');
			this.applyDrillManage = properties.handlers.okCallback;
			this.cancelDrillManage = properties.handlers.cancelCallback;
			this.reactDomNode = this.$el[0];
			this.handlers = properties.handlers;
			if (!this.handlers) {
				throw new Error('Handlers must be provided to manage drill through definitions');
			}
			this.content = properties.content;
			this.dashboard = properties.dashboard;
			this.drillThroughModelApi = properties.drillThroughModelApi;
			this.iconsFeature = this.dashboard.getFeature('Icons');
		}

		/**
		 * Renders the dialog
		 */
		render() {
			ReactDOM.render(
				<DrillThroughManageComponents
					label={this.label}
					openDialog={true}
					applyDrillManage={this.onApply.bind(this)}
					onCancel={this.onCancel.bind(this)}
					iconsFeature = {this.iconsFeature}
					content = {this.content}
					dashboard = {this.dashboard}
					drillThroughModelApi = {this.drillThroughModelApi}
					handlers={this.handlers}
				/>,
				this.reactDomNode
			);
		}

		remove() {
			if (this.reactDomNode) {
				ReactDOM.unmountComponentAtNode(this.reactDomNode);
			}
			if (this.$el){
				this.$el.remove();
				this.$el = null;
			}
			super.remove();
		}

		/**
		 * Applies drill through manage
		 */
		onApply() {
			this.applyDrillManage();
			this.remove();
		}


		/**
		 * Cancels the current drill through manage operation
		 */
		onCancel() {
			this.cancelDrillManage();
			this.remove();
		}
	}

	return DrillThroughManageDialog;
});
